export default __webpack_public_path__ + "static/media/pergolas.c13c5265.png";